import TabContext from './TabContext';
import React, { useContext, useEffect } from 'react';

const useTabSetting = (willShowTab) => {
  const TabSetting = useContext(TabContext);
  useEffect(() => {
    if (!TabSetting) return;

    TabSetting.setTab(willShowTab);
  }, [TabSetting, willShowTab]);
};

export default useTabSetting;
